var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","placement":"top-start"}},[_c('div',{staticClass:"tool-tip-content",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n    "+_vm._s(_vm.langName)+" "+_vm._s(_vm.code)+"\n  ")]),_vm._v(" "),_c('span',{class:_vm.flagClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }